{
  "header": "Please lift your {{bureauName}} Credit Freeze and resubmit.",
  "greeting": "We can't proceed with your application. It appears that you have a freeze on your credit report.",
  "creditFreezeLink": "this {{bureauName}} page",
  "uplift": {
    "nextSteps": "Please contact  {{bureauName}} to lift the freeze. Head to <CreditFreezeLink /> on how to lift the freeze online, by phone or by mail. Once that's complete, you can reapply for Uplift Pay Monthly.",
    "thanks": "You can also start over with a new application. Anyone 18 or older can apply for Uplift Pay Monthly."
  },
  "flexpay": {
    "nextSteps": "Please contact  {{bureauName}} to lift the freeze. Head to <CreditFreezeLink /> on how to lift the freeze online, by phone or by mail. Once that's complete, you can resubmit your application for Flex Pay.",
    "thanks": "You can also start over with a new application. Anyone 18 or older can apply for Flex Pay."
  }
}
